import { Controller } from '../utils/controller';

enum Direction {
  Left = 'LEFT',
  Right = 'RIGHT'
}
type IndexFunction = (currentIndex: number, arrayLength: number) => number;
type IndexFunctionsRecord = Record<Direction, IndexFunction>;

const nextIndexFunctions: IndexFunctionsRecord = {
  [Direction.Right]: (currentIndex, length) => (currentIndex === length - 1 ? 0 : currentIndex + 1),
  [Direction.Left]: (currentIndex, length) => (currentIndex === 0 ? length - 1 : currentIndex - 1)
};

export default class extends Controller {
  static targets = ['rotatingOffer'];
  static requiredTargets = [];
  static classes = ['hide'];
  static requiredClasses = [];
  static values = {
    rotateInterval: { type: Number, default: 5000 },
    autoplay: { type: Boolean, default: true }
  };

  // TARGETS
  declare rotatingOfferTargets: HTMLDivElement[];

  // CLASSES
  declare hideClasses: string[];

  // VALUES
  declare rotateIntervalValue: number;
  declare autoplayValue: boolean;

  // LOCAL STATE
  private currentOfferIndex: number;
  private rotatingInterval: NodeJS.Timer | number;

  initialize() {
    this.currentOfferIndex = 0;
    this.rotatingInterval = -1;

    this.showCurrent();
    this.handleAutoplay();
  }

  private handleAutoplay() {
    if (this.autoplayValue && this.rotateIntervalValue) {
      this.rotatingInterval = setInterval(this.navigate.bind(this), this.rotateIntervalValue);
    }
  }

  private resetInterval() {
    if (this.rotatingInterval) {
      clearInterval(this.rotatingInterval);
    }
  }

  private calculateNextIndex({
    direction,
    currentIndex,
    length
  }: {
    direction: Direction;
    currentIndex: number;
    length: number;
  }) {
    const getNextIndex = nextIndexFunctions[direction];

    return getNextIndex(currentIndex, length);
  }

  private navigate(direction: Direction = Direction.Right) {
    this.resetInterval();
    this.currentOfferIndex = this.calculateNextIndex({
      direction: direction,
      currentIndex: this.currentOfferIndex,
      length: this.rotatingOfferTargets.length
    });
    this.showCurrent();
    this.handleAutoplay();
  }

  private showCurrent() {
    for (let i = 0; i < this.rotatingOfferTargets.length; i++) {
      if (i != this.currentOfferIndex) {
        this.rotatingOfferTargets[i].classList.add(...this.hideClasses);
        continue;
      }

      this.rotatingOfferTargets[i].classList.remove(...this.hideClasses);
    }
  }

  nextOffer() {
    this.navigate();
  }

  prevOffer() {
    this.navigate(Direction.Left);
  }
}
